import getApiUrl from "./getUrl";
import getUrl from "./getUrl";

export async function scan(id, sid) {
    try {

        const res = await fetch(getUrl() + "/api/adapter/scan?id=" + id + "&sid=" + sid, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include", // Include cookies with the request
        });
        return res
    } catch (err) {
    }
}